import { Box } from '@mui/material';
import { RenderTable } from '../../../../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
interface IProps {
  moduleData: any;
  tniTopics: any;
  TickCrossSelectField: any;
  allDepartment: any;
  getTopicByDepartment: any;
  autocompleteData: any;
  setAutocompleteData: any;
}

const TController = ({
  moduleData,
  tniTopics,
  TickCrossSelectField,
  allDepartment,
  getTopicByDepartment,
  autocompleteData,
  setAutocompleteData,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            tniTopics,
            allDepartment,
            getTopicByDepartment,
            autocompleteData,
            setAutocompleteData,
          }}
        />
        <TBody {...{ moduleData, tniTopics, TickCrossSelectField }} />
        {/* <TFoot
          preparedBy={moduleData.report_prepared_by}
          approvedBy={moduleData.report_approved_by}
        /> */}
      </RenderTable>
    </Box>
  );
};

export default TController;
